import { FC, useState, useRef, useCallback, useEffect } from 'react';
import { ReactComponent as IconArrowLightLeft } from '../../../../../../assets/images/icons/ic_arrow_light_left.svg';
import { useMediaQuery } from 'react-responsive';
import { MD } from '../../../../../../config/constants';
import { isToday, useClosePopupOver, roundToHour, mobileAndTabletCheck } from '../../../../../../lib/utils';
import classNames from 'classnames';

import './styles.sass';
import { DateControlValue, RangeDaysSelect, RangeDate } from '@russpass/partner-front-ui';

type RangeValType = {
    from: Date | null;
    to: Date | null;
};

type SelectRangeProps = {
    hide: () => void;
    getData: (params: RangeValType) => void;
};

const SelectRangeDate: FC<SelectRangeProps> = ({ hide, getData }) => {
    const rangePicker = useRef(null);
    const rangePickerWrap = useRef<HTMLDivElement>(null);
    const isPhoneOrTablet = useMediaQuery({ query: `(max-width: ${MD}px)` }) && mobileAndTabletCheck();
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [rangeDate, setRangeDate] = useState<RangeValType | undefined>(undefined);

    const toMonthMobile = new Date();
    toMonthMobile.setMonth(new Date().getMonth());

    const resetRangeDate = () => {
        setRangeDate(undefined);
        //@ts-expect-error
        rangePicker?.current?.clearSelectedValue();
    };

    const getRangeData = useCallback(() => {
        rangeDate && getData(rangeDate);
        hide();
    }, [rangeDate, getData, hide]);

    const handleRangeChange = (values: DateControlValue) => {
        const period = values[0] as RangeDate;

        if (period?.from && period?.to) {
            let from = new Date(period?.from),
                to = new Date(period?.to);

            from?.setHours(0, 0, 0, 0);

            if (isToday(new Date(to))) {
                to = roundToHour(new Date());
            } else {
                to.setHours(23, 59, 59, 999);
            }

            setRangeDate({
                from,
                to,
            });
        }
    };

    useEffect(() => {
        isPhoneOrTablet &&
            wrapperRef.current &&
            rangePickerWrap.current &&
            wrapperRef?.current.scrollTo(0, rangePickerWrap.current?.scrollHeight);
    }, [isPhoneOrTablet]);

    useClosePopupOver(wrapperRef, hide);

    return (
        <div className="selected-range" ref={wrapperRef}>
            <div className="selected-range__header">
                <div className="selected-range__header-button-wrap">
                    <button className="selected-range__header-button" onClick={hide}>
                        <IconArrowLightLeft />
                    </button>
                </div>
                <div className="selected-range__header-title">Свой период</div>
                <div className="selected-range__header-button-wrap"></div>
            </div>
            <div ref={rangePickerWrap} className="selected-range__calendar-wrap">
                <RangeDaysSelect
                    ref={rangePicker}
                    numberOfMonths={isPhoneOrTablet ? 60 : 2}
                    toMonth={new Date()}
                    onSelect={handleRangeChange}
                    disabledOptions={[{ after: new Date() }]}
                    disableYearNavigation
                    isResponsive
                    value={
                        rangeDate?.from && rangeDate?.to
                            ? [
                                  {
                                      from: new Date(rangeDate.from).toString(),
                                      to: new Date(rangeDate.to).toString(),
                                  },
                              ]
                            : []
                    }
                />
            </div>

            <div
                className={classNames(
                    'selected-range__buttons-wrap',
                    !rangeDate && 'selected-range__buttons-wrap__hidden'
                )}
            >
                <div className="selected-range__button-wrap">
                    <button
                        className="selected-range__button selected-range__button--primary"
                        disabled={rangeDate === undefined}
                        onClick={getRangeData}
                    >
                        Выбрать
                    </button>
                </div>
                <div className="selected-range__button-wrap">
                    <button
                        className="selected-range__button selected-range__button--second"
                        disabled={rangeDate === undefined}
                        onClick={resetRangeDate}
                    >
                        Сбросить
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SelectRangeDate;
